import {
	FeedbackService,
	Id,
	Loading,
	createFeedbackQuestionService,
	useDynamicConfig,
	useHasPermission,
} from "@dgs/core";
import { useDetailsQuery } from "@dgs/core/lib/api/baseQueries";
import { FC, useMemo } from "react";
import { useParams } from "react-router";
import { FeedbackDetailsWithPreview } from "../../../feedbacks/FeedbackDetailsWithPreview";

interface Props {
	eventId: Id;
	feedbackService: FeedbackService;
}

export const EventFeedbackDetailsPage: FC<Props> = ({ feedbackService, eventId }) => {
	const { feedbackId = "" } = useParams();
	const { frontendUrl } = useDynamicConfig();
	const canUpdate = useHasPermission(["feedback.update"]);
	const canDelete = useHasPermission(["feedback.delete"]);
	const feedbackQuestionService = useMemo(
		() => createFeedbackQuestionService(["events", `${eventId}`], feedbackId),
		[eventId, feedbackId],
	);
	const { data: feedback } = useDetailsQuery(feedbackId, feedbackService);

	if (!feedback) {
		return <Loading />;
	}

	return (
		<FeedbackDetailsWithPreview
			feedbackId={feedbackId}
			feedbackService={feedbackService}
			feedbackQuestionService={feedbackQuestionService}
			canUpdate={!feedback.isTemplate && canUpdate}
			canDelete={!feedback.isTemplate && canDelete}
			previewUrl={`${frontendUrl}/feedbacks/${feedbackId}/preview`}
		/>
	);
};
